import React, { Component } from 'react'

class CartPopoverContent extends Component {
    render() {
        const { order } = this.props;
        const { name, address, province, postalCode } = order.address;

        return (
            <div>
                <div className="qiuck-review">
                    <div className="head-popover">
                        <div className="order-code">
                            <label>{`Order #${order.PaymentResponse.tranRef}`}</label>
                        </div>
                        <div className="price">
                            <label>{order.totalPrice} ฿</label>
                        </div>
                    </div>
                    <div className="body-popover">
                        <label>Items</label>
                        <div className="card">
                            <div className="card-body">
                                <div className="card-body-img">
                                    <img src="/resources/img/img-product.png" alt="Product" />
                                </div>
                                <div className="card-body-name">
                                    <span title="Me Nutra - Sesame Oi">Me Nutra - Sesame Oi</span>
                                    <p>x1</p>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-body">
                                <div className="card-body-img">
                                    <img src="/resources/img/img-product.png" alt="Product" />
                                </div>
                                <div className="card-body-name">
                                    <span title="Me Nutra - Sesame Oi Me Nutra - Sesame Oi Me Nutra - Sesame Oi">Me Nutra - Sesame Oi Me Nutra - Sesame Oi Me Nutra - Sesame Oi</span>
                                    <p>x1</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="foot-popover">
                        <label>Address</label>
                        <div style={{ fontSize: '16px' }}>
                            <p style={{ fontWeight: 'bold' }}>{name}</p>
                            <p>{address}</p>
                            <p>{province}</p>
                            <p>{postalCode}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CartPopoverContent


// WEBPACK FOOTER //
// ./src/views/orders/CartPopoverContent.js